import PropTypes from 'prop-types';
import { useState } from 'react';
import { useRouter } from 'next/router';

import { useTranslation } from 'next-i18next';

import { Select } from '@gogovan/entier-web-core/ext/mui/Select';
import { MenuItem } from '@gogovan/entier-web-core/ext/mui/MenuItem';
import { InputLabel } from '@gogovan/entier-web-core/ext/mui/InputLabel';
import { FormControl } from '@gogovan/entier-web-core/ext/mui/FormControl';
import { OutlinedInput } from '@gogovan/entier-web-core/ext/mui/OutlinedInput';
import { useSaveSettingMutation } from '@/modules/setting/setting.api';

const LanguageSelection = ({ variant = 'standard' }) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale, push, pathname, asPath } = router;
  const [language, setLanguage] = useState(locale);
  const [sendSaveSettingRequest] = useSaveSettingMutation();

  const languages = [
    {
      value: 'en-HK',
      label: 'English',
    },
    // {
    //   value: 'ko',
    //   label: '한국어',
    // },
    {
      value: 'zh-HK',
      label: '中文 (香港)',
    },
    // {
    //   value: 'hi',
    //   label: 'हिन्दी भाषा',
    // },
    // {
    //   value: 'vi',
    //   label: 'Tiếng việt',
    // },
  ];

  const handleChangeLanguage = async (event) => {
    const previouslySelectedLanguage = language;
    const newSelectedLanguage = event.target.value;

    setLanguage(newSelectedLanguage);

    try {
      if (variant === 'standard') {
        push(pathname, asPath, { locale: newSelectedLanguage });
      } else {
        await sendSaveSettingRequest({
          clientUserConfig: { preferences: { preferredLanguage: event.target.value } },
        }).unwrap();
      }
    } catch (error) {
      setLanguage(previouslySelectedLanguage);
    }
  };

  const languageMenuItems = (languageOptions) => {
    const options = [];
    languageOptions.forEach((l) => {
      options.push(
        <MenuItem value={l.value} key={l.value}>
          {l.label}
        </MenuItem>
      );
    });
    return options;
  };

  return variant === 'standard' ? (
    <Select value={language} variant='standard' disableUnderline defaultValue='en' onChange={handleChangeLanguage}>
      {languageMenuItems(languages)}
    </Select>
  ) : (
    <FormControl>
      <InputLabel shrink id='select-language-label'>
        {t('language')}
      </InputLabel>
      <Select
        value={language}
        variant='outlined'
        defaultValue={locale}
        onChange={handleChangeLanguage}
        input={<OutlinedInput label={t('language')} />}
        labelId='select-language-label'
      >
        {languageMenuItems(languages)}
      </Select>
    </FormControl>
  );
};

LanguageSelection.propTypes = {
  variant: PropTypes.oneOf(['standard', 'outlined']),
};

// eslint-disable-next-line import/prefer-default-export
export { LanguageSelection };
